import logo from "../../assets/logoCopie.png";

const PrivacyPolicy = () => {
  document.title = "Dev'Alls - Politique de confidentialité";
  return (
    <main className="mainLegales">
      <section className="sectionLegale">
        <div className="retourFleche">
          <p>
            <a className="retour" href="/legalnotices">
              <span className="returnHome">{"<"}</span> Retour
            </a>
          </p>
        </div>
        <div className="containLogo">
          <a className="navbar-brand" href="/devalls">
            <img src={logo} className="logo_mentions" alt="logo" />
          </a>
        </div>
        <div className="divLegales">
          <h1 className="h1Mentions">Politique de Confidentialité</h1>

          <section className="legalNotice">
            <h2 className="h2Mentions">1. Introduction</h2>
            <div className="pMentions">
              <p>
                Nous attachons une grande importance à la protection de votre
                vie privée et à la gestion de vos données personnelles. Cette
                politique de confidentialité a pour but de vous informer sur la
                manière dont nous collectons, utilisons et protégeons vos
                données personnelles lorsque vous utilisez notre site web.
              </p>
            </div>
          </section>

          <section className="legalNotice">
            <h2 className="h2Mentions">2. Collecte des données personnelles</h2>
            <div className="pMentions">
              <p>
                Nous collectons des informations lorsque vous remplissez des
                formulaires sur notre site, comme lorsque vous vous inscrivez à
                notre newsletter, demandez un devis ou nous contactez via notre
                formulaire. Les données collectées peuvent inclure :
              </p>

              <ul className="ulMentions">
                <li>Nom et prénom</li>
                <li>Adresse e-mail</li>
                <li>Numéro de téléphone</li>
                <li>Adresse IP</li>
                <li>Historique de navigation sur notre site</li>
              </ul>
            </div>
          </section>

          <section className="legalNotice">
            <h2 className="h2Mentions">3. Utilisation des données</h2>
            <div className="pMentions">
              <p>Les données collectées sont utilisées pour :</p>
              <ul className="ulMentions">
                <li>Répondre à vos demandes et vous fournir nos services</li>
                <li>Améliorer nos services et l’expérience utilisateur</li>
                <li>
                  Envoyer des informations commerciales ou des promotions (si
                  vous avez accepté)
                </li>
              </ul>
            </div>
          </section>

          <section className="legalNotice">
            <h2 className="h2Mentions">4. Partage des données</h2>
            <div className="pMentions">
              <p>
                Nous ne vendons ni ne louons vos données personnelles à des
                tiers. Cependant, nous pouvons être amenés à partager certaines
                informations avec des partenaires externes de confiance pour la
                gestion technique et fonctionnelle de notre site. Ces
                partenaires respectent également les règles de confidentialité.
              </p>
            </div>
          </section>

          <section className="legalNotice">
            <h2 className="h2Mentions">5. Protection des données</h2>
            <div className="pMentions">
              <p>
                Nous mettons en place des mesures de sécurité pour protéger vos
                données contre l'accès non autorisé, l'altération, la
                divulgation ou la destruction. Toutefois, aucune méthode de
                transmission sur Internet n'est complètement sûre, et nous ne
                pouvons garantir une sécurité absolue.
              </p>
            </div>
          </section>

          <section className="legalNotice">
            <h2 className="h2Mentions">6. Vos droits</h2>
            <div className="pMentions">
              <p>
                Conformément au RGPD, vous disposez des droits suivants sur vos
                données personnelles :
              </p>
              <ul className="ulMentions">
                <li>
                  Droit d'accès : vous pouvez demander des informations sur les
                  données que nous détenons à votre sujet.
                </li>
                <li>
                  Droit de rectification : vous pouvez demander à corriger les
                  informations incorrectes.
                </li>
                <li>
                  Droit à l'effacement : vous pouvez demander à supprimer vos
                  données dans certaines conditions.
                </li>
                <li>
                  Droit à la portabilité : vous pouvez demander à récupérer vos
                  données sous un format structuré.
                </li>
                <li>
                  Droit à la limitation du traitement : vous pouvez demander de
                  limiter l’utilisation de vos données dans certaines
                  situations.
                </li>
              </ul>
              <p>
                Pour exercer vos droits, veuillez nous contacter à{" "}
                <a
                  className="linkContact linkMention"
                  href="mailto:contact.devalls@gmail.com"
                >
                  contact.devalls@gmail.com
                </a>
                .
              </p>
            </div>
          </section>

          <section className="legalNotice">
            <h2 className="h2Mentions">7. Cookies</h2>
            <div className="pMentions">
              <p>
                Ce site utilise des cookies pour améliorer l'expérience
                utilisateur. Vous pouvez choisir d'accepter ou de refuser
                l'utilisation de cookies via les paramètres de votre navigateur.
              </p>
              <p>
                Pour plus d'informations sur les cookies utilisés, veuillez
                consulter notre{" "}
                <a href="/cookiespolicy" className="linkContact linkMention">
                  Politique de Cookies
                </a>
                .
              </p>
            </div>
          </section>

          <section className="legalNotice">
            <h2 className="h2Mentions">
              8. Modifications de la politique de confidentialité
            </h2>
            <div className="pMentions">
              <p>
                Nous nous réservons le droit de modifier cette politique de
                confidentialité à tout moment. En cas de changement, la date de
                la dernière mise à jour sera indiquée au bas de cette page.
              </p>
            </div>
          </section>
          <div className="pMentions">
            <p className="mt-4 text-gray-600">
              Dernière mise à jour : 10/02/2025
            </p>
          </div>
        </div>
      </section>
    </main>
  );
};

export default PrivacyPolicy;
